import PropTypes from "prop-types"
import { Typography } from "@mui/material"

// Non-blocking notice above a populated chart — for conditions that don't empty the chart
// (a batch-count cap, some points failing to load) but the user can't otherwise tell happened.
// hasFailedBatches can also trip from the live-tick query, so the copy avoids naming "batches".
export default function ChartNotice({ isTruncated, hasFailedBatches }) {
  const messages = [
    isTruncated && "Showing only the most recent batches.",
    hasFailedBatches && "Some intraday data failed to load and is not shown.",
  ].filter(Boolean)

  if (!messages.length) return null

  return (
    <Typography variant="caption" color="text.secondary" className="chart-notice">
      {messages.join(" ")}
    </Typography>
  )
}

ChartNotice.propTypes = {
  isTruncated: PropTypes.bool,
  hasFailedBatches: PropTypes.bool,
}
